import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { isFirstResponderUpgradePlan, isMilitaryUpgradePlan } from 'Utils/SheerIdHelpers';
import { getPlanDisplayPrice, getPlanSelectFrequencyLabel, getSimplifiedPlanDisplayName } from 'Utils/Plans';
import { resetPromoCode } from 'State/PromoCode/PromoCodeActions';
import { PlanSelectionModal } from 'Features/Plans/PlanSelection/PlanSelection';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import './PlanPreview.css';

const Price = ({ price, freqLabel }) => {
  if (!price) return null;

  return (
    <div className="price">
      {price}
      <span className="planFrequency">{freqLabel}</span>
    </div>
  );
};

const LargePrice = ({ price, freqLabel }) => {
  if (!price) return null;

  return (
    <div className="largePrice">
      {price}
      {freqLabel}
    </div>
  );
};

//Always showing change Plans button even if only 1 selectable plan since sign up plans screen shows more plan details.
export const PlanPreview = ({
  plan,
  changePlanLink,
  isSheerIdFree,
  hasActiveSubscription,
  promoMsg,
  selectPlan,
  selectablePlans,
}) => {
  const [showModal, toggleModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetPromoCode());
    };
  }, [dispatch]);

  if (!plan) return null;

  /*
  TODO: Can probably simplify & improve isStandalonePrice logic to look at plan.hasPrePayPromotion instead
  Same for all of the logic in "planPreviewRight" div below 
  */

  //No "then" in front of the price and has slightly different format
  const isStandalonePrice =
    isMilitaryUpgradePlan(plan.packageID) ||
    isFirstResponderUpgradePlan(plan.packageID) ||
    (promoMsg && hasActiveSubscription);

  const { pricingTitle, purchaseFunnelHardcodeName, specialPreviewBottomRight, priceHardcode, frequencyLabelHardcode } =
    plan.config;

  const price = priceHardcode || getPlanDisplayPrice(plan.planPrice);
  const freqLabel = frequencyLabelHardcode || getPlanSelectFrequencyLabel(plan);
  const planHighlight = promoMsg ? promoMsg : pricingTitle;
  const pricingSubtitle = plan?.config?.pricingSubtitle ?? 'then';

  const handleChangePlanEvent = () => {
    trackEvent(TRACKING_ENUMS.EVENT_CHANGE_PLAN_STARTED, {
      page_start_source: 'payment',
      page_plan_name: plan.packageID,
    });
  };

  const changePlanButton = changePlanLink ? (
    <Link onClick={handleChangePlanEvent} className="changePlanLink" to={changePlanLink}>
      <span className="changePlanLinkText">Change Plan</span>
    </Link>
  ) : (
    <button
      className="changePlanLink"
      onClick={() => {
        handleChangePlanEvent();
        toggleModal(true);
      }}
    >
      <span className="changePlanLinkText">Change Plan</span>
    </button>
  );

  return (
    <>
      <div className="planPreview">
        <div className="planPreviewLeft">
          <div className="name">{purchaseFunnelHardcodeName || getSimplifiedPlanDisplayName(plan)}</div>
          {!isSheerIdFree && selectablePlans.length > 1 && changePlanButton}
        </div>
        <div className="planPreviewRight">
          {hasActiveSubscription && !promoMsg && !isSheerIdFree && <LargePrice price={price} freqLabel={freqLabel} />}
          {(!hasActiveSubscription || !!promoMsg || isSheerIdFree) && (
            <div className="planHighlight">{planHighlight}</div>
          )}
          {((!isSheerIdFree && !hasActiveSubscription) || promoMsg) && (
            <div className="previewBottomRight">
              {!isStandalonePrice && !specialPreviewBottomRight && (
                <div className={`changePlanLinkText pricingSubtitle`}>{pricingSubtitle}</div>
              )}
              {!specialPreviewBottomRight && <Price price={price} freqLabel={freqLabel} />}
              {specialPreviewBottomRight && (
                <div className="specialPreviewBottomRight">{specialPreviewBottomRight}</div>
              )}
            </div>
          )}
        </div>
      </div>
      <PlanSelectionModal
        show={showModal}
        selectPlan={(planId) => {
          selectPlan(planId);
          toggleModal(false);
        }}
        onClose={() => toggleModal(false)}
        selectedPlan={plan}
        plans={selectablePlans}
      />
    </>
  );
};
